var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEthereumLogo = function SvgEthereumLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "EthereumLogo_svg__w-4 EthereumLogo_svg__h-4 EthereumLogo_svg__mr-2 EthereumLogo_svg__-ml-1 EthereumLogo_svg__text-[#626890]",
    "aria-hidden": "true",
    "data-prefix": "fab",
    "data-icon": "ethereum",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M311.9 260.8 160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4 8 290.6 160 512l152-221.4-152 92.8z"
  })));
};

export default SvgEthereumLogo;